var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import 'rxjs/add/operator/map';
import { Injectable } from '@angular/core';
import { ApiProvider } from '../api/api';
import { EnvironmentProvider, ServerEnvironment, } from '../environment/environment';
import { LoadingAlertProvider } from '../loading-alert/loading-alert';
import { SessionProvider } from '../session/session';
import { UserProvider } from '../user/user';
let AnalyticsProvider = AnalyticsProvider_1 = class AnalyticsProvider {
    constructor(environment, api, userService, session, loadingAlert) {
        this.environment = environment;
        this.api = api;
        this.userService = userService;
        this.session = session;
        this.loadingAlert = loadingAlert;
        console.log('Hello AnalyticsProvider Provider');
    }
    setup() {
        this.userService.currentUser$.subscribe(user => {
            if (user) {
                this.setUser(user.uid);
                this.handleStoredDeeplink();
            }
        });
    }
    setUser(uid) {
        /* no op */
    }
    trackView(title) {
        if (this.userService.isLoggedIn$.value) {
            this.trackServerPageView(title);
            console.log('Server: track event', title);
        }
    }
    trackEvent(eventName) {
        if (this.userService.isLoggedIn$.value) {
            this.trackServerEvent(eventName);
            console.log('Server: track event', eventName);
        }
    }
    trackServerEvent(eventName) {
        this.api
            .call({
            url: '/analytics',
            method: 'POST',
            body: { event_name: eventName },
        })
            .subscribe(response => {
            console.log('Tracked server event');
        }, error => {
            console.log('Error tracking event', error);
        });
    }
    trackServerPageView(pageName) {
        this.api
            .call({
            url: '/page_views',
            method: 'POST',
            body: { page_name: pageName },
        })
            .subscribe(response => {
            console.log('Tracked server page view');
        }, error => {
            console.log('Error tracking page view', error);
        });
    }
    handleDeeplink(data) {
        let user = this.userService.currentUser$.getValue();
        if (data.user_uid && data.auth_key) {
            this.loadingAlert.showLoaderWithText('Logging in');
            this.userService
                .logout()
                .then(() => {
                if (data.environment == 'beta') {
                    return this.environment.switchServer(ServerEnvironment.Beta);
                }
            })
                .then(() => {
                this.userService.loginWithAuthKey(data.auth_key, data.user_uid).then(() => {
                    this.loadingAlert.dismissLoader();
                }, () => {
                    this.loadingAlert.dismissLoader();
                    this.loadingAlert.showToastAlert('Error logging in');
                });
            });
        }
        else if (user) {
            this.attributeUser(data);
        }
        else {
            this.session.set(AnalyticsProvider_1.USER_ATTRIBUTION_KEY, data);
        }
    }
    handleStoredDeeplink() {
        this.session
            .get(AnalyticsProvider_1.USER_ATTRIBUTION_KEY)
            .then((data) => {
            if (data) {
                this.handleDeeplink(data);
                this.session.remove(AnalyticsProvider_1.USER_ATTRIBUTION_KEY);
            }
        });
    }
    attributeUser(data) {
        let stringifiedData = JSON.stringify(data);
        this.userService.updateUser({
            ref: data.ref,
            deepLinkData: stringifiedData,
        });
    }
};
AnalyticsProvider.USER_ATTRIBUTION_KEY = 'user_attribution';
AnalyticsProvider = AnalyticsProvider_1 = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [EnvironmentProvider,
        ApiProvider,
        UserProvider,
        SessionProvider,
        LoadingAlertProvider])
], AnalyticsProvider);
export { AnalyticsProvider };
var AnalyticsProvider_1;
//# sourceMappingURL=analytics.js.map


// WEBPACK FOOTER //
// ./src/providers/analytics/analytics.ts.pre-build-optimizer.js